import Vue from 'vue'
import VueI18n from 'vue-i18n'
import zhCNVxeTable from 'vxe-table/lib/locale/lang/zh-CN'
import enUSVxeTable from 'vxe-table/lib/locale/lang/en-US'
import enLocale from './en'
import zhLocale from './zh'
import Cookies from 'js-cookie'
import { getLangCookie } from '@/services/utils/modules/authBj'

// 初始化 VueI18n plugin
Vue.use(VueI18n)

const messages = {
  zh: {
    ...zhCNVxeTable,
    ...zhLocale,
  },
  en: {
    ...enUSVxeTable,
    ...enLocale,
  }
}

export function getLanguage() {
  const chooseLanguage = getLangCookie()
  if (chooseLanguage) return chooseLanguage

  // if has not choose language
  const language = (navigator.language || navigator.browserLanguage).toLowerCase()
  console.log('language', language)
  const locales = Object.keys(messages)
  for (const locale of locales) {
    if (language.indexOf(locale) > -1) {
      return locale
    }
  }
  return 'zh'
}

if (module.hot) {
  module.hot.accept(['./en', './zh'], function() {
    i18n.setLocaleMessage('en', require('./en').default)
    i18n.setLocaleMessage('zh', require('./zh').default)
  })
}

const i18n = new VueI18n({
  locale: getLanguage(),
  messages,
})

export default i18n
